import { ServerMaintenanceRedirectException } from '../errors/index';
import { ParsedResponse } from '../types/types';

export default ([res, json]: ParsedResponse): ParsedResponse => {
  if (!res.ok && json.errors && json.errors[0].status === 307) {
    throw new ServerMaintenanceRedirectException();
  }

  return [res, json];
};
